import React, { useMemo } from 'react';

import useEvent from '@lyearn/core/hooks/useEvent';
import useScreen from '@lyearn/core/hooks/useScreen';
import { PopoverContentPosition } from '@lyearn/ui';
import { Popover } from '@lyearn/ui';
import { LabelCategoryEntityConfig } from '@/components/FilterManager/EntityFilter/entity/task-label';
import { getLabelCategoryOption } from '@/components/FilterManager/EntityFilter/entity/task-label/utils';
import FilterBody from '@/components/FilterNew/components/Body';
import { FilterBodyProps } from '@/components/FilterNew/components/Body/types';
import { NewFilterOption } from '@/components/FilterNew/types';
import { LabelCategoryFragment } from '@/modules/tasks/graphql/queries/generated/labelCategory';

const LIST_CONFIG: FilterBodyProps['listConfig'] = {
  ...LabelCategoryEntityConfig,
  listVariant: 'single-ungrouped-infinite',
};

function LabelCategoryMenu({
  actionItemId,
  children,
  open,
  labelCategory,
  popoverPosition,
  onOpenChange,
  onLabelCategoryChange,
}: {
  actionItemId?: string;
  children: React.ReactNode;
  open: boolean;
  labelCategory?: LabelCategoryFragment | null;
  popoverPosition?: PopoverContentPosition;
  onOpenChange: (open: boolean) => void;
  onLabelCategoryChange: (
    statusInfo: LabelCategoryFragment,
    id?: string,
  ) => Promise<string | boolean | null | undefined> | void;
}) {
  const onChange = useEvent((value: NewFilterOption<{}, LabelCategoryFragment>[]) => {
    onLabelCategoryChange(value?.[0]?.item!, actionItemId);
  });
  const { isMobile } = useScreen();

  const initialSelectedOptions = useMemo(
    () => (labelCategory ? [getLabelCategoryOption(labelCategory)] : []),
    [labelCategory],
  );

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      {({ open }) => (
        <>
          <Popover.Button>{children}</Popover.Button>
          {open ? (
            <Popover.Content
              position={popoverPosition}
              renderAs={isMobile ? 'bottom-sheet' : 'popover'}>
              <FilterBody
                initialSelectedOptions={initialSelectedOptions}
                listConfig={LIST_CONFIG}
                onChange={onChange}
                onToggle={onOpenChange}
              />
            </Popover.Content>
          ) : null}
        </>
      )}
    </Popover>
  );
}

export default LabelCategoryMenu;
